module.exports = __webpack_public_path__ + "img/qrcode0.88722be0.jpg";